// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.AUPBWjXbpqC9YB .MrHMMwOv0okM48 {
  margin: 0 -12px;
  padding: 6px 12px;
}
.AUPBWjXbpqC9YB .MrHMMwOv0okM48:hover {
  background-color: var(--ds-background-neutral-hovered, #091e4224);
  cursor: pointer;
}
.AUPBWjXbpqC9YB .MrHMMwOv0okM48.uuQLh6BXOaAluJ {
  pointer-events: none;
}
.AUPBWjXbpqC9YB .MrHMMwOv0okM48.uuQLh6BXOaAluJ a {
  color: var(--ds-text-disabled, #091e424f);
}
.AUPBWjXbpqC9YB .MrHMMwOv0okM48.uuQLh6BXOaAluJ a .DpWFgFerYQm26i svg {
  color: var(--ds-text-disabled, #091e424f);
}
.AUPBWjXbpqC9YB .MrHMMwOv0okM48.uuQLh6BXOaAluJ a .C0VeKnvCgfo4PW {
  color: var(--ds-text-disabled, #091e424f);
}
.AUPBWjXbpqC9YB .MrHMMwOv0okM48.uuQLh6BXOaAluJ:hover {
  background-color: none;
  cursor: not-allowed;
}
.AUPBWjXbpqC9YB .MrHMMwOv0okM48 a {
  color: var(--ds-text, #172b4d);
  text-decoration: none;
}
.AUPBWjXbpqC9YB .MrHMMwOv0okM48 a .DpWFgFerYQm26i {
  margin-left: 4px;
}
.AUPBWjXbpqC9YB .MrHMMwOv0okM48 a .C0VeKnvCgfo4PW {
  display: block;
  margin-top: 4px;
  color: var(--ds-text-subtle, #44546f);
  font-size: 12px;
  line-height: 16px;
}
.AUPBWjXbpqC9YB hr {
  margin: 8px 0;
}
.AUPBWjXbpqC9YB .qVCTPws5Fe9pA3 {
  color: var(--ds-text-subtle, #44546f);
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `AUPBWjXbpqC9YB`,
	"roleOption": `MrHMMwOv0okM48`,
	"disabled": `uuQLh6BXOaAluJ`,
	"checkIcon": `DpWFgFerYQm26i`,
	"roleDescription": `C0VeKnvCgfo4PW`,
	"soleAdminDisclaimer": `qVCTPws5Fe9pA3`
};
export default ___CSS_LOADER_EXPORT___;
